import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BackendInterceptor } from '../../../services/backend-interceptor/backend-interceptor.service';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { UsersListConfigService } from '../../../services/users-list-config/users-list-config.service';
import { User } from '../../../state/auth/types';

@Component({
    selector: 'lib-manage-users-wrapper',
    templateUrl: './manage-users-wrapper.component.html',
    styleUrls: ['./manage-users-wrapper.component.css'],
    standalone: false
})
export class ManageUsersWrapperComponent implements OnInit {
  public usersListConfigService = inject(UsersListConfigService);
  protected modalService = inject(NgbModal);
  protected router = inject(Router);
  protected backendInterceptor = inject(BackendInterceptor);
  protected gungModalService = inject(GungModalService);

  public listUser = true;

  backendBaseUrl = this.backendInterceptor.getBaseUrl();


  ngOnInit() {}

  openCreateUser(): void {
    this.gungModalService.createUser({}, false).then(
      (user: User) => {
        if (!!user) {
          this.router.navigate(['/admin/users-details/' + user.username]);
        }
      },
      reason => {}
    );
  }
}
